import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MACHINE_OWNER_TYPES } from 'src/app/shared/constants/machine-field-options';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-machine-master',
  templateUrl: './add-machine-master.component.html',
  styleUrl: './add-machine-master.component.css',
})
export class AddMachineMasterComponent implements OnInit {
  form!: FormGroup;
  owners: any[] = [];
  vendors: any[] = [];
  ownerTypes = MACHINE_OWNER_TYPES;
  saving = false;
  editingId: number | null = null;

  constructor(private fb: FormBuilder, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      owner_name: ['', Validators.required],
      owner_type: ['PRINCIPAL_OWNER', Validators.required],
      contact_phone: [''],
      contact_email: [''],
      address: [''],
      gst_number: [''],
      pan_number: [''],
      vendor_company_id: [''],
      notes: [''],
    });
    this.api.listVendorAccounts().subscribe({
      next: (res: any) => (this.vendors = res?.data || []),
      error: () => (this.vendors = []),
    });
    this.load();
  }

  load(): void {
    this.api.listMachineOwners().subscribe({
      next: (res: any) => (this.owners = res?.data || []),
      error: (err) => this.toastr.error(err?.error?.message || 'Failed to load owners'),
    });
  }

  edit(row: any): void {
    this.editingId = row.id;
    this.form.patchValue({
      owner_name: row.owner_name,
      owner_type: row.owner_type,
      contact_phone: row.contact_phone,
      contact_email: row.contact_email,
      address: row.address,
      gst_number: row.gst_number,
      pan_number: row.pan_number,
      vendor_company_id: row.vendor_company_id || '',
      notes: row.notes,
    });
  }

  reset(): void {
    this.editingId = null;
    this.form.reset({ owner_type: 'PRINCIPAL_OWNER', vendor_company_id: '' });
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const body = { ...this.form.value };
    if (!body.vendor_company_id) body.vendor_company_id = null;
    const req = this.editingId
      ? this.api.updateMachineOwner(this.editingId, body)
      : this.api.createMachineOwner(body);
    req.subscribe({
      next: () => {
        this.saving = false;
        this.toastr.success(this.editingId ? 'Owner updated' : 'Machine owner onboarded');
        this.reset();
        this.load();
      },
      error: (err) => {
        this.saving = false;
        this.toastr.error(err?.error?.message || 'Save failed');
      },
    });
  }
}
